var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "140px",
                  },
                },
                [
                  _c("h4", [_vm._v("运营产品：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品类型：" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { min: 1 },
                          model: {
                            value: _vm.selType,
                            callback: function ($$v) {
                              _vm.selType = $$v
                            },
                            expression: "selType",
                          },
                        },
                        _vm._l(_vm.agentDevice, function (item) {
                          return item.taked == 1
                            ? _c(
                                "el-checkbox",
                                { attrs: { label: item.depend_type } },
                                [_vm._v(_vm._s(item.depend_name))]
                              )
                            : _vm._e()
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("基础信息：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "开通类型：", prop: "role_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择开通类型",
                            disabled: _vm.$route.params.id ? true : false,
                          },
                          model: {
                            value: _vm.form.role_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "role_id", $$v)
                            },
                            expression: "form.role_id",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "后台管理员", value: 1 },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.role, function (item) {
                            return _c("el-option", {
                              attrs: {
                                label: item.role_name,
                                value: item.role_id,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入下级代理姓名" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码：", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入手机号" },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v("此手机号码会作为登录账户"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.id
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "登录密码：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "会作为用户代理登录的密码" },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "运营区域：" } },
                    [
                      _c("v-distpicker", {
                        attrs: {
                          province: _vm.form.charge_province,
                          city: _vm.form.charge_city,
                          area: _vm.form.charge_county,
                        },
                        on: { selected: _vm.selectCity },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司地址：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入公司地址" },
                        model: {
                          value: _vm.form.company_address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "company_address", $$v)
                          },
                          expression: "form.company_address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "投放场地：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择投放场地" },
                          model: {
                            value: _vm.form.put_place,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "put_place", $$v)
                            },
                            expression: "form.put_place",
                          },
                        },
                        _vm._l(_vm.put_place, function (item) {
                          return _c("el-option", {
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "二维码网址：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入二维码网址" },
                        model: {
                          value: _vm.form.qrcode_address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "qrcode_address", $$v)
                          },
                          expression: "form.qrcode_address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("分润比例")]),
                  _vm._v(" "),
                  _vm._l(_vm.agentDevice, function (item, index) {
                    return [
                      _vm.selType.indexOf(item.depend_type) > -1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: item.depend_name + "：" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder:
                                      "最高不能超过" +
                                      (_vm.powerInfo[
                                        _vm.config.profit_key[
                                          item.depend_type
                                        ] + "percent"
                                      ] || 100) +
                                      "%",
                                  },
                                  model: {
                                    value:
                                      _vm.form[
                                        _vm.config.profit_key[
                                          item.depend_type
                                        ] + "percent"
                                      ],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        _vm.config.profit_key[
                                          item.depend_type
                                        ] + "percent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form[config.profit_key[item.depend_type] + 'percent' ]",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.depend_type == 3 &&
                      _vm.selType.indexOf(item.depend_type) > -1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "电费：" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder:
                                      "最高不能超过" +
                                      (_vm.powerInfo.zhuang_elec_percent ||
                                        100) +
                                      "%",
                                  },
                                  model: {
                                    value: _vm.form.zhuang_elec_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "zhuang_elec_percent",
                                        $$v
                                      )
                                    },
                                    expression: "form.zhuang_elec_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.depend_type == 3 &&
                      _vm.selType.indexOf(item.depend_type) > -1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "服务费：" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder:
                                      "最高不能超过" +
                                      (_vm.powerInfo.zhuang_service_percent ||
                                        100) +
                                      "%",
                                  },
                                  model: {
                                    value: _vm.form.zhuang_service_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "zhuang_service_percent",
                                        $$v
                                      )
                                    },
                                    expression: "form.zhuang_service_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.depend_type == 3 &&
                      _vm.selType.indexOf(item.depend_type) > -1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "会员：" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder:
                                      "最高不能超过" +
                                      (_vm.powerInfo.member_card_percent ||
                                        100) +
                                      "%",
                                  },
                                  model: {
                                    value: _vm.form.member_card_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "member_card_percent",
                                        $$v
                                      )
                                    },
                                    expression: "form.member_card_percent",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("代理权限")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "基本权限：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.powerInfo.check_order == 1,
                              expression: "powerInfo.check_order == 1",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.check_order,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "check_order", $$v)
                            },
                            expression: "form.check_order",
                          },
                        },
                        [_vm._v("查看订单")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.powerInfo.withdraw_right == 1 ||
                                _vm.checkRoles(["partner"]),
                              expression:
                                "powerInfo.withdraw_right == 1 || checkRoles(['partner'])",
                            },
                          ],
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.checkRoles(["terminal"]),
                          },
                          model: {
                            value: _vm.form.withdraw_right,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "withdraw_right", $$v)
                            },
                            expression: "form.withdraw_right",
                          },
                        },
                        [_vm._v("提现")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.powerInfo.withdraw_right == 1 ||
                                _vm.checkRoles(["partner"]),
                              expression:
                                "powerInfo.withdraw_right == 1 || checkRoles(['partner'])",
                            },
                          ],
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.checkRoles(["terminal"]),
                          },
                          model: {
                            value: _vm.form.withdraw_right_batch,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "withdraw_right_batch", $$v)
                            },
                            expression: "form.withdraw_right_batch",
                          },
                        },
                        [_vm._v("批量(下级)提现")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.powerInfo.finish_order == 1,
                              expression: "powerInfo.finish_order == 1",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.finish_order,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "finish_order", $$v)
                            },
                            expression: "form.finish_order",
                          },
                        },
                        [_vm._v("结束订单")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.powerInfo.drawback_order == 1,
                              expression: "powerInfo.drawback_order == 1",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.drawback_order,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawback_order", $$v)
                            },
                            expression: "form.drawback_order",
                          },
                        },
                        [_vm._v("订单退款")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.powerInfo.steal_order_right == 1 ||
                                  _vm.form.old_steal_order_right == 1) &&
                                _vm.checkRoles(["terminal", "partner"]),
                              expression:
                                "(powerInfo.steal_order_right == 1 || form.old_steal_order_right == 1) && checkRoles(['terminal','partner'])",
                            },
                          ],
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.powerInfo.steal_order_right == 0,
                          },
                          model: {
                            value: _vm.form.steal_order_right,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "steal_order_right", $$v)
                            },
                            expression: "form.steal_order_right",
                          },
                        },
                        [_vm._v("掉单功能")]
                      ),
                      _vm._v(" "),
                      _vm.checkRoles(["terminal"])
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.wx_ad_right,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "wx_ad_right", $$v)
                                },
                                expression: "form.wx_ad_right",
                              },
                            },
                            [_vm._v("微信广告")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkRoles(["terminal"])
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.buy_goods_right,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "buy_goods_right", $$v)
                                },
                                expression: "form.buy_goods_right",
                              },
                            },
                            [_vm._v("出售设备")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.checkRoles(["partner"]) && _vm.checkHidRole("agentTxsxf")
                    ? _c(
                        "div",
                        [
                          _c("h4", [_vm._v("提现手续费")]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "收取方式：" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.withdrawFeeObj.config_mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.withdrawFeeObj,
                                        "config_mode",
                                        $$v
                                      )
                                    },
                                    expression: "withdrawFeeObj.config_mode",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("跟随原配置"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("单独比例"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("单独金额"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.withdrawFeeObj.config_mode == 1
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "提现手续费比例：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "flex1",
                                        attrs: {
                                          oninput:
                                            "value=value.replace(/[^\\d.]/g,'')",
                                        },
                                        model: {
                                          value:
                                            _vm.withdrawFeeObj.withdraw_rate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.withdrawFeeObj,
                                              "withdraw_rate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "withdrawFeeObj.withdraw_rate",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("%"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.withdrawFeeObj.config_mode == 2
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "提现手续费金额：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "flex1",
                                        attrs: {
                                          oninput:
                                            "value=value.replace(/[^\\d.]/g,'')",
                                        },
                                        model: {
                                          value:
                                            _vm.withdrawFeeObj.withdraw_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.withdrawFeeObj,
                                              "withdraw_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "withdrawFeeObj.withdraw_amount",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: _vm.clickSubmit },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }